var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Page"},[_c('div',{staticClass:"Page-Content"},[_c('iframe',{staticStyle:{"width":"100%","height":"calc(100% - 7px)","margin":"0","padding":"0"},attrs:{"src":"https://www.mixgovr.com/AUDAX/6c6dlaville-drone/","frameborder":"0"}})])])
}]

export { render, staticRenderFns }